module.exports = __webpack_public_path__ + "static/media/food-delivery.c63ca6d5.png";